export default __webpack_public_path__ + "static/Surf-the-Web-Safely-Transcript-57d4dc9f38f702ff6d4f1862a58664c6.pdf";